<template>
  <div class="bill">
    <BillForm ref="bill" @saveSuccess="saveSuccess" />
    <div class="bill-btn">
      <el-button type="primary" plain @click="submit" :loading="btnLoading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import BillForm from "./ReserveBillForm.vue";
export default {
  components: {
    BillForm,
  },
  data() {
    return {
      btnLoading: false,
    };
  },
  methods: {
    submit() {
      this.btnLoading = true;
      this.$refs.bill.submitForm();
    },
    saveSuccess() {
      this.btnLoading = false;
      this.$message.success("保存成功");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.bill {
  width: 700px;
  &-btn {
    padding-left: 150px;
  }
}
.address {
  width: 400px;
}
.editAddress {
  margin-left: 10px;
  cursor: pointer;
  color: #3073f4;
}
</style>
